import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const newRovoSearchRoute: InvariantJiraRoute = {
	name: 'jira-rovo-search-new',
	path: '/jira/rovo-search',
	exact: true,
};
